import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import * as styles from './AutoProlong.desktop.css';
import classNames from 'classnames';

interface IAutoProlongDesktopProps {
  value: boolean;
  isDisabled: boolean;
  onChange(): void;
}

export const AutoProlongDesktop = ({ value, isDisabled, onChange }: IAutoProlongDesktopProps) => {
  return (
    <div className={classNames(styles['wrapper'], isDisabled && styles['disabled'])}>
      <Checkbox label="Автопродление публикации" checked={value} disabled={isDisabled} onChange={onChange} />
    </div>
  );
};
